export const EMAIL_REGEX = /^[A-z0-9._-]+@[A-z0-9._-]+\.[A-z]+$/;

export const makeEmailFormatValidator = ({allowEmpty = true}:{allowEmpty ?: boolean} = {}) => ({
    check      : (email:string) => !email && allowEmpty || EMAIL_REGEX.test(email),
    getMessage : () => "Please enter a valid email address",
});

export const emailFormatValidator = makeEmailFormatValidator();

